/* Theme JS */
document.addEventListener('DOMContentLoaded', function() {
  // Cart count refresh
  fetch('/cart.js').then(r => r.json()).then(cart => {
    document.querySelectorAll('[aria-label="Cart"]').forEach(el => {
      el.innerHTML = '⌂ · ' + cart.item_count;
    });
  }).catch(() => {});
});
